var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.123,
    height: 16.332,
    viewBox: "0 0 20.123 16.332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-copy",
    transform: "translate(4 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_1330",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_77",
    "data-name": "\\u30D1\\u30B9 77",
    d: "M3.375,19.52H19.5V6.188H3.375ZM4.615,7.428H18.258V18.28H4.615Z",
    transform: "translate(-3.375 -6.188)",
    fill: "#f39628"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_78",
    "data-name": "\\u30D1\\u30B9 78",
    d: "M3.375,19.52H8.066l.475-9.142L19.5,9.655V6.188H3.375ZM4.615,7.428H18.258V9.094H7.323V18.28H4.615Z",
    transform: "translate(-7.375 -9.188)",
    fill: "#f39628"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_1329",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1329",
    transform: "translate(-0.688 0.203)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_89",
    "data-name": "\\u7DDA 89",
    x2: 7,
    transform: "translate(5.25 6.463)",
    fill: "none",
    stroke: "#f39628",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_90",
    "data-name": "\\u7DDA 90",
    y2: 7,
    transform: "translate(8.75 2.963)",
    fill: "none",
    stroke: "#f39628",
    strokeWidth: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.1a48af5c890cef96ba2d97e0caa9db5f.svg";
export { ForwardRef as ReactComponent };